const initQuizNivel = () => {
  const quizContents = document.querySelectorAll('.quiz__content');

  if (quizContents.length === 0) return;

  const baseUrl = "/";

  const rutas = {
      a: `${baseUrl}/quiz/resultado-muy-bajo`,
      b: `${baseUrl}/quiz/resultado-bajo`,
      c: `${baseUrl}/quiz/resultado-medio`,
      d: `${baseUrl}/quiz/resultado-alto`
  };

  function mostrarPregunta(id) {

    quizContents.forEach(content => {
        content.style.display = 'none';
    });

    const siguiente = document.querySelector(
        `.quiz__content[data-id="${id}"]`
    );

    if (siguiente) {
        siguiente.style.display = 'block';
        actualizarProgreso(id);
    }
  }

  function calcularResultado() {
      const conteo = {
          a: 0,
          b: 0,
          c: 0,
          d: 0
      };

      document.querySelectorAll('.respuesta-activa').forEach(active => {
          const respuesta = active.dataset.r;

          if (conteo.hasOwnProperty(respuesta)) {
              conteo[respuesta]++;
          }
      });

      /**
       * Prioridad en empate:
       * a > b > c > d
       * Excepto empate total 3/3/3/3 = c
       */
      if (
          conteo.a === 3 &&
          conteo.b === 3 &&
          conteo.c === 3 &&
          conteo.d === 3
      ) {
          return 'c';
      }

      let resultado = 'a';
      let mayor = conteo.a;

      ['b', 'c', 'd'].forEach(letra => {
          if (conteo[letra] > mayor) {
              mayor = conteo[letra];
              resultado = letra;
          }
      });

      return resultado;
  }

  document.addEventListener('click', function (e) {
      const botonPregunta = e.target.closest('.btn-blue');
      const opcion = e.target.closest('.quiz__content-opciones:not(select)');

      if (botonPregunta) {

        const preguntaActual = document.querySelector('.quiz__content[style*="block"]');

        if (preguntaActual) {

            const actual = parseInt(
                preguntaActual.dataset.id.replace('pregunta-', ''),
                10
            );

            const destino = parseInt(
                botonPregunta.dataset.id.replace('pregunta-', ''),
                10
            );

            // Solo hacer scroll cuando regresa
            if (destino < actual) {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }

        mostrarPregunta(botonPregunta.dataset.id);
        return;
      }

      if (!opcion) return;

      const pregunta = opcion.dataset.pregunta;

      document
          .querySelectorAll(`.quiz__content[data-id="${pregunta}"] .quiz__content-opciones`)
          .forEach(opt => opt.classList.remove('respuesta-activa'));

      opcion.classList.add('respuesta-activa');

      const numeroPregunta = parseInt(pregunta.replace('pregunta-', ''), 10);

      if (numeroPregunta === 15) {
          const resultado = calcularResultado();
          window.location.href = rutas[resultado];
          return;
      }

      if (numeroPregunta === 3 && opcion.classList.contains('resp-text')) {
          return;
      }

      const quiz = document.querySelector('.quiz');

      if (quiz) {
          quiz.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
          });
      }

      mostrarPregunta(`pregunta-${numeroPregunta + 1}`);
  });

  function actualizarProgreso(idPregunta) {

    const barra = document.querySelector('.quiz__steps-bar-progress');

    if (!barra) return;

    const numeroPregunta = parseInt(
        idPregunta.replace('pregunta-', ''),
        10
    );

    const totalPreguntas = 15;

    const porcentaje = (numeroPregunta / totalPreguntas) * 100;

    barra.style.width = `${porcentaje}%`;
  }
}

export default initQuizNivel;